import { EventEmitter, Injectable, Output } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import {
  HubConnection,
  HubConnectionBuilder,
  HubConnectionState,
  IHttpConnectionOptions,
  LogLevel
} from '@microsoft/signalr';

@Injectable()
export abstract class HubService<T1> {
  protected hubConnection!: HubConnection;
  @Output() hubConnectionStarted: EventEmitter<void> = new EventEmitter();
  @Output() streamReceivedData: EventEmitter<T1> = new EventEmitter();
  @Output() streamDeleteDataReceived: EventEmitter<T1> = new EventEmitter();

  abstract addDataListener(): void;

  private isConnected$ = new BehaviorSubject<boolean>(false);

  private options: IHttpConnectionOptions = {
    withCredentials: false,
    accessTokenFactory: () => {
      return localStorage.getItem('access_token') ?? '';
    }
  };

  initHub(hubUrl: string): void {
    this.hubConnection = new HubConnectionBuilder()
      .withUrl(hubUrl, this.options)
      .withAutomaticReconnect()
      .configureLogging(LogLevel.None)
      .build();

    this.hubConnection
      .start()
      .then(() => {
        this.isConnected$.next(true);
        this.hubConnectionStarted.emit();
      })
      .catch(() => {
        this.isConnected$.next(false);
        setTimeout(() => this.initHub(hubUrl), 5000);
      });

    this.addDataListener();
    this.deleteDataListener();
    this.deleteDataListener();
    this.subscribeToHubReconnection();
  }

  subscribeToHubReconnection(): void {
    this.hubConnection.onreconnected(() => {
      this.isConnected$.next(true);
    });
  }

  stopHub(): void {
    this.isConnected$.next(false);
    this.hubConnection?.stop();
  }

  get isHubConnected(): boolean {
    return this.hubConnection?.state === HubConnectionState.Connected;
  }

  protected deleteDataListener(): void {}
}
